class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    /* Add To Cart */
      $(document).on("click", '.custom_drawer_products_item_buy_box .add_to_cart_ajax', function(e) {
        e.preventDefault();   
        console.log("asdasd");
        var id = $(this).parents('.custom_drawer_products_item_buy_box').find('select[name="variant_id_custom"]').val(); 
        jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              quantity: 1,
              id: id
            },
            dataType: 'json', 
            success: function (data) { 
                jQuery("cart-drawer").load(location.href + " #CartDrawer", function() {
  initUpsellSwiper(document); // <— re-init upsell slider
  jQuery("cart-drawer").removeClass('is-empty').addClass('active');
  jQuery("body").addClass('overflow-hidden');
});
             } 
        });
      });
  
      $(document).on("click", '.custom_button .add_to_cart_ajax', function(e) {
      e.preventDefault();   
      var id = $(this).attr('variant_id'); 
      var this_element =  jQuery(this);
      this_element.addClass('loading_hk');
      jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: id
      },
        dataType: 'json', 
       success: function (data) { 
      jQuery("cart-drawer").load(location.href + " #CartDrawer", function() {
  initUpsellSwiper(document); // <— re-init upsell slider
  jQuery("cart-drawer").removeClass('is-empty').addClass('active');
  jQuery("body").addClass('overflow-hidden');
  this_element.removeClass('loading_hk');
});
       } 
      });
      });

      /* Variant change wise add to cart */
      $(document).on("change", '.product_option_select select', function(e) {
      e.preventDefault();   
      var id = $(this).val(); 
      var this_element =  jQuery(this);
      this_element.prev().addClass('loading_hk');
      jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: id
      },
        dataType: 'json', 
       success: function (data) { 
      jQuery("cart-drawer").load(location.href + " #CartDrawer");
      setTimeout(function() {
      jQuery("cart-drawer").removeClass('is-empty').addClass('active');
      jQuery("body ").addClass('overflow-hidden');
      this_element.prev().removeClass('loading_hk'); 
      this_element.val(''); 
        
      }, 500);
       } 
      });
      });
          
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
    const quick_btn = document.querySelectorAll('.card_drawer_product .quick-add__submit');
    quick_btn.forEach(function(quick_add_btn) {
      quick_add_btn.addEventListener('click', function() {
        setTimeout(() => {
          document.querySelector('.drawer__close').click();
        }, "1100");
      });
    });
    
    // Use the shipping threshold calculator if available
    var win_free_shipping_price;
    if (window.shippingThresholdCalculator) {
      win_free_shipping_price = window.shippingThresholdCalculator.currencyThreshold;
    } else {
      // Fallback to the attribute value if the calculator is not available
      win_free_shipping_price = parseInt(document.querySelector(".totals__total-value").getAttribute("free_shipping_price").replace(/[^\d\.]/g, ""));
    }
    
    var drawer_total_amt = parseInt(document.querySelector(".totals__total-value").getAttribute("data").replace(/[^\d\.]/g, ""));
    var currency_symbol = document.querySelector(".totals__total-value").getAttribute("symbol");
    const currency = win_free_shipping_price;
    var remaining_amt = currency - drawer_total_amt;
    document.querySelector(".progress_remain .progress_amount").textContent = remaining_amt.toFixed(2);
    document.querySelector(".progress_remain .currency_symbol").textContent = currency_symbol;
    document.querySelectorAll(".top-announcement-bar .progress_amount-announce").forEach(el => el.textContent = remaining_amt.toFixed(2));

    // Shipping Rate
    const shipping__price_cms = window.settings.shipping_price_cms;
    const shipping_currency = 100 * shipping__price_cms * window.Shopify.currency.rate / 100;
    document.querySelector(".shipping_value .standard-shipped").textContent = shipping_currency.toFixed(2);
    
    var math_rounds = ((currency - drawer_total_amt) / currency) * 100;
    var math_round = 100 - math_rounds;
    
    if (math_round >= 100) {
    math_round = 100;
    document.querySelectorAll(".shipping_data .progress_remain").forEach(el => el.style.display = "none");
    document.querySelectorAll(".shipping_data .free_shipping").forEach(el => el.style.display = "block");
    document.querySelector(".shipping_value .standard-shipped").textContent = 'Free';
    document.querySelector(".shipping_value .currency_symbol").style.display = 'none';
    document.querySelectorAll(".announcement-progress-bar-label").forEach(el => el.style.display = "none");
    document.querySelectorAll(".announcement-free-shipping-label").forEach(el => el.style.display = "flex");
    // Add complete class to hide the indicator
    document.querySelector(".progress_shipping").classList.add("complete");
} else {
    document.querySelectorAll(".shipping_data .progress_remain").forEach(el => el.style.display = "block");
    document.querySelectorAll(".shipping_data .free_shipping").forEach(el => el.style.display = "none");
    document.querySelector(".shipping_value .currency_symbol").style.display = 'inline-block';
    document.querySelectorAll(".announcement-progress-bar-label").forEach(el => el.style.display = "flex");
    document.querySelectorAll(".announcement-free-shipping-label").forEach(el => el.style.display = "none");
    // Remove complete class to show the indicator
    document.querySelector(".progress_shipping").classList.remove("complete");
}
     
    var progress = document.querySelector(".progress-meter");
    progress.style.width = math_round + "%";
    

    var swiper = new Swiper('.slider_collection', {
      slidesPerView: 2,
      slidesPerGroup: 3,
      spaceBetween: 20,
      navigation: {
        nextEl: '.coll-button-next',
        prevEl: '.coll-button-prev',
      },
      breakpoints: {
        767: {
          slidesPerView: 2,
        }
      }
    });
    
    // Add this new event handler for free product variant changes
    $(document).on("change", '.free_product_js select[name="variant_id"]', function(e) {
      e.preventDefault();
      const selectedVariantId = $(this).val();
      const line = $(this).attr('line');
      const removeLink = $(this).attr('remove_link');
      const currentId = $(this).attr('current_id');
      const quantity = $(this).attr('quantity');

      // First remove the current variant
      fetch(removeLink, {
        method: 'GET',
      })
      .then(response => {
        // Then add the new variant
        const data = {
          items: [{
            id: selectedVariantId,
            quantity: parseInt(quantity)
          }]
        };
        
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
        });
      })
      .then(response => response.json())
      .then(data => {
        // Refresh cart drawer contents
        jQuery("cart-drawer").load(location.href + " #CartDrawer", function() {
          // Re-initialize any necessary components after reload
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && !cartDrawer.classList.contains('animate')) {
            cartDrawer.classList.add('animate', 'active');

          }
            initUpsellSwiper(cartDrawer || document); // <— re-init upsell slider

        });
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    });

    $(document).on('change', '.free_product_js input[type="radio"]', function() {
      const productContainer = $(this).closest('.free_product_js');
      const sizeValue = productContainer.find('input[name*="size"]:checked').val();
      const colorValue = productContainer.find('input[name*="colour"]:checked').val();
      const variantSelect = productContainer.find('select[name="variant_id"]');
      
      // Find matching variant option
      variantSelect.find('option').each(function() {
        const variantTitle = $(this).attr('data-title');
        if (variantTitle.includes(sizeValue) && variantTitle.includes(colorValue)) {
          variantSelect.val($(this).val()).trigger('change');
          return false;
        }
      });
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';
/*
    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }
*/
    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          initUpsellSwiper(document);

        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}


/* ===== Init Upsell Swiper (wraps existing DOM) ===== */
function initUpsellSwiper(root = document){
  // find the upsell track
  const track = root.querySelector('.custom_drawer_products_flex');
  if (!track) return;

  // If we already transformed it, just (re)init Swiper and return
  if (track.closest('.upsell-swiper')) {
    const swiperEl = track.closest('.upsell-swiper').swiperEl || track.closest('.upsell-swiper');
    if (swiperEl && swiperEl.__upsellSwiper && typeof swiperEl.__upsellSwiper.update === 'function') {
      swiperEl.__upsellSwiper.update();
    }
    return;
  }

  // Build Swiper markup around the existing items
  const container = document.createElement('div');
  container.className = 'swiper upsell-swiper';

  const wrapper = document.createElement('div');
  wrapper.className = 'swiper-wrapper';

  // Move each upsell card into a .swiper-slide
  const items = Array.from(track.children).filter(el => el.classList.contains('custom_drawer_products_item'));
  items.forEach((card) => {
    const slide = document.createElement('div');
    slide.className = 'swiper-slide';
    slide.appendChild(card); // move card inside slide
    wrapper.appendChild(slide);
  });

  // Arrows
  const prev = document.createElement('button');
  prev.className = 'upsell-prev';
  prev.setAttribute('aria-label','Previous upsell');
  prev.innerHTML = '&#10094;';

  const next = document.createElement('button');
  next.className = 'upsell-next';
  next.setAttribute('aria-label','Next upsell');
  next.innerHTML = '&#10095;';

  // Replace original track with Swiper container
  track.replaceWith(container);
  container.appendChild(wrapper);
  container.appendChild(prev);
  container.appendChild(next);

  // Keep a reference to pass to Swiper later
  container.swiperEl = container;

  // Initialize Swiper (assumes Swiper is already loaded in your theme)
  const instance = new Swiper(container, {
    slidesPerView: 1.4,         // << your requested 1.4
    spaceBetween: 12,
    watchOverflow: true,
    navigation: { nextEl: next, prevEl: prev },
    // optional: enable drag
    grabCursor: true
  });

  container.__upsellSwiper = instance;
}

// Run once when DOM is ready (if drawer is present)
document.addEventListener('DOMContentLoaded', () => initUpsellSwiper(document));
